/*
----------------------------------------------------------------------------
Usage:
----------------------------------------------------------------------------
import Tooltip from './modules/tooltip'
_('tooltip', 'element').nodes().map((el) => new Tooltip(el))
*/
import tippy from 'tippy.js'
import { _ } from '../utils.js'

class Tooltip {
    constructor(el) {
        this.el = el
        this.tip = _(this.el.dataset.target, 'element').node()

        if (!this.tip) {
            return false
        }

        this.instance = tippy(this.el, {
            allowHTML: true,
            animation: 'shift-toward-subtle',
            arrow: false,
            content: this?.tip.innerHTML,
            hideOnClick: true,
            interactive: true,
            placement: 'auto',
            trigger: 'click',
            maxWidth: 415,
            onShown: (instance) => {
                _('tip-close', 'element')
                    .nodeFrom(instance.popper)
                    .addEventListener('click', () => {
                        instance.hide()
                    })
            },
        })
    }
}
export default Tooltip
